import { ApplicationsLayout } from "@app/layouts/applications-layout/applications-layout";
import { PrivateRouter } from "@app/private-route";
import { useLanguage } from "@context/language-context";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { Loader } from "@ui/loader/loader";
import { SidebarProvider } from "@widgets/sidebar/sidebar";
import { Suspense, useEffect } from "react";

export const Route = createFileRoute("/_layout")({
	component: RouteComponent,
});

function RouteComponent() {
	const { currentLanguage } = useLanguage();
	const root = document.getElementById("root");

	useEffect(() => {
		if (currentLanguage !== "ar") {
			root?.setAttribute("dir", "ltr");
			return;
		}
		root?.setAttribute("dir", "rtl");
	}, [currentLanguage, root]);

	return (
		<Suspense fallback={<Loader size="xl" color="accent" wrap />}>
			<PrivateRouter>
				<SidebarProvider>
					<ApplicationsLayout>
						<Outlet />
					</ApplicationsLayout>
				</SidebarProvider>
			</PrivateRouter>
		</Suspense>
	);
}
